/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPriorityWaitTimeFromJSON, StreemApiPriorityWaitTimeToJSON, } from './';
export function StreemApiPriorityWaitTimesFromJSON(json) {
    return StreemApiPriorityWaitTimesFromJSONTyped(json, false);
}
export function StreemApiPriorityWaitTimesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'priorityWaitTime': !exists(json, 'priority_wait_time') ? undefined : (json['priority_wait_time'].map(StreemApiPriorityWaitTimeFromJSON)),
    };
}
export function StreemApiPriorityWaitTimesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'priority_wait_time': value.priorityWaitTime === undefined ? undefined : (value.priorityWaitTime.map(StreemApiPriorityWaitTimeToJSON)),
    };
}
//# sourceMappingURL=StreemApiPriorityWaitTimes.js.map